import React, { useEffect, useState } from "react";
import SideMenuTile from "./SideMenuTile";
import { useDispatch, useSelector } from "react-redux";
import SearchForm from "../../../component/search-form";
import { sanitizeInput } from "../../../utils";
import { GET_USER_LIST } from "../../../redux/constants";

const Sidebar = ({ activeGroup, setActiveGroup, setPage, hasMoreRef }) => {
  const dispatch = useDispatch();
  const { dataList } = useSelector(state => state.chat);
  const { email } = useSelector(state => state.auth);
  const [search, setSearch] = useState("");

  useEffect(() => {

    let markReadGroup = dataList.findIndex(
      (item) => item.id === activeGroup.id
    );

    if(markReadGroup !== -1){
      dataList[markReadGroup]["is_read"] = ""
    }
    dispatch({
      type: GET_USER_LIST,
      payload: dataList,
    });

  }, [activeGroup]);

  const handleSearch = (e) => {
    const value = sanitizeInput(e.target.value);
    setSearch(value);
  };

  const itemList = search === "" ? dataList : dataList.filter((item) =>
      item.name
        .toLowerCase()
        .replace(/\s+/g, "")
        .includes(search.toLowerCase().replace(/\s+/g, ""))
  );

  return (
    <div className="h-full xxs:w-60 md:w-80 lg:w-[360px] bg-white shrink-0 pr-4">
      <div>
        <div className="w-full pb-6">
          <SearchForm
            placeholder="Search"
            onChange={handleSearch}
            value={search}
            formClass="grow"
          />
        </div>
      </div>
      <div
        className="h-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        style={{ maxHeight: "calc(100vh - 165px)" }}
      >
        {itemList.length > 0 && itemList.map((item) => (
          item.email !== email && (
            <SideMenuTile
              group={item} 
              name={item.name}
              message={item?.message || ""}
              activeGroup={activeGroup}
              setActiveGroup={setActiveGroup}
              setPage={setPage}
              hasMoreRef={hasMoreRef}
            />
          )
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
